import React, { useState, useEffect, useRef } from 'react';
import Header from './Header'; // Import Header component
import Sidebar from './Sidebar'; // Import Sidebar component
import './CreatePrescription.css'; // Add your styling here
import './Dashboard.css'; // Ensure you create this CSS file for styling
import {axiosInstance, axiosAmarlabInstance} from './helper/axiosConfig';
import AsyncCreatableSelect from 'react-select/async-creatable';
import moment from 'moment';
import MedicineList from '../components/MedicineList';
import toast, { Toaster } from 'react-hot-toast';
import MedLogo from '../assets/img/medicine.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { districts } from '../data/districts';
import { thanasByDistrict } from '../data/thanasByDistrict';
import { faArrowLeft, faChevronLeft, faChevronRight, faCamera, faPrint, faShareAlt, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Link, useLocation, useNavigate } from 'react-router-dom'; // Import Link and useLocation for navigatio
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { isAdmin, isDoctor } from './helper/authRoles';
import axios from 'axios';

// Function to generate random colors for avatars
const getRandomColor = () => {
  const colors = ['#f56565', '#68d391', '#63b3ed', '#ed8936', '#f6ad55', '#9f7aea', '#48bb78', '#4299e1'];
  return colors[Math.floor(Math.random() * colors.length)];
};

// Utility function to get the first letter of the patient's name
const getAvatarLetter = (name) => {
  return name ? name.charAt(0).toUpperCase() : '?';
};

function CreatePrescription() {
  const [step, setStep] = useState(1); // State to track the current step
  const [success, setSuccess] = useState(0); // State to track the current step
  const [investigations, setInvestigations] = useState([]); // State to store fetched investigations
  const [advices, setAdvices] = useState([]); // State to store fetched advices
  const [availableThanas, setAvailableThanas] = useState([]); // State for available thanas based on district
  //for medicine info
  const [MedicineListItems, setMedicineListItems] = useState(null)
  const [medications, setMedications] = useState([]);
  const [mediType, setMediType] = useState('');
  const [mediName, setMediName] = useState('');
  const [mediId, setMediId] = useState('');
  const [mediMoring, setMediMoring] = useState('0');
  const [mediAfternoon, setMediAfternoon] = useState('0');
  const [mediEvening, setMediEvening] = useState('0');
  const [mediWithMeal, setMediWithMeal] = useState('');
  const [mediDays, setMediDays] = useState('');
  const [mediAdvice, setMediAdvice] = useState('');
  const [mediAdvices, setMediAdvices] = useState([]);
  const [mediStrength, setMediStrength] = useState('');
  const [mediMixture, setMediMixture] = useState('');
  const [mediDosesPuffTime, setMediDosesPuffTime] = useState('');
  const [patientExists, setPatientExists] = useState(false);  // New state to check if patient exists
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [lastPrescriptionId, setLastPrescriptionId] = useState(null)
  const [loading, setLoading] = useState(false);
  const [patients, setPatients] = useState([]);
  const [patientNotFound, setPatientNotFound] = useState(false);
  const [countPrescription, setCountPrescription] = useState(false);
  const [appoinmentID, setAppoinmentID] = useState(0);
  const popupRef = useRef(null);

  const [fromSneho, setFromSneho] = useState(false);
  const [snehoPrescriptionId, setSnehoPrescriptionId] = useState('');
  const [orders, setOrders] = useState([]);
  const popupHeaderRef = useRef(null);

  const API_KEY = 'sneho-api-key-123456789'; // Replace with your actual API key

  const [mealChoice, setMealChoice] = useState(true);
  const [nebulization, setNebulization] = useState(false);
  const [tablet, setTablet] = useState(false);
  const [medicationType, setMedicationType] = useState('');
  const [medicationPlaceholder, setMedicationPlaceholder] = useState(
    'Number of Drops (e.g. 2 drops per nostril/eye etc.)'
  );
  const [activeTab, setActiveTab] = useState('treatment');
  const today = new Date().toISOString().split('T')[0];
  const datePickerRef = useRef(null);
  const flatpickrInstance = useRef(null);
  const [schedule, setSchedule] = useState([]);
  const [availableDays, setAvailableDays] = useState([]);
  const [error, setError] = useState('');
  const history = useNavigate(); // Hook for navigation
  const weightInputRef = useRef(null);
  const [selectedMedicine, setSelectedMedicine] = useState(null);
  const [showStickyPopup, setShowStickyPopup] = useState(true);
  const [prescriptions, setPrescriptions] = useState([]);
  const [patientId, setPatientId] = useState('');
  const [parsedUserDoctorInfo, setParsedUserDoctorInfo] = useState({})
  const medicineTypeOptions = [
    'Drop',
    'Fleet Enema',
    'Inhaler',
    'Injections',
    'Nasal Spray',
    'Nebulization',
    'Powder',
    'Cream',
    'Ointments',
    'Suppository',
    'Syrup',
    'Tablet',
    'Capsule',
  ];

  useEffect(() => {
      // Optional: Log or perform actions if the popupHeaderRef is ready
      if (popupHeaderRef.current) {
        console.log('Popup Header Ref is ready:', popupHeaderRef.current);
      }
    }, [popupHeaderRef]);


  // const fetchOrders = async () => {
  //   try {
  //     const response = await axiosAmarlabInstance.get('/order/sneho-order-tree/', {
  //       params: {
  //         from_sneho: 1,
  //         sneho_prescription_id: 244,
  //       },
  //     });
  //     console.log(response.data);
  //     setOrders(response.data.results)
  //   } catch (error) {
  //     console.error('Error fetching orders:', error.response || error);
  //   }
  // };
  //
  //
  // useEffect(() => {
  //   fetchOrders();
  // }, []);


  const findClosestMatch = (doseFrom) => {
    if (!doseFrom) return '';

    // Match medicineTypeOptions that are most similar to doseFrom
    const lowerDoseFrom = doseFrom.toLowerCase();
    return (
      medicineTypeOptions.find((type) =>
        lowerDoseFrom.includes(type.toLowerCase())
      ) || ''
    );
  };



  const handleDrag = (e) => {
    const popup = popupRef.current;
    if (!popup) return;

    // Determine if it's a touch event or mouse event
    const isTouchEvent = e.type === "touchstart";

    // Get initial positions
    const startX = isTouchEvent ? e.touches[0].clientX : e.clientX;
    const startY = isTouchEvent ? e.touches[0].clientY : e.clientY;

    let shiftX = startX - popup.getBoundingClientRect().left;
    let shiftY = startY - popup.getBoundingClientRect().top;

    const moveAt = (pageX, pageY) => {
      popup.style.left = `${pageX - shiftX}px`;
      popup.style.top = `${pageY - shiftY}px`;
    };

    const onMove = (event) => {
      const pageX = isTouchEvent ? event.touches[0].pageX : event.pageX;
      const pageY = isTouchEvent ? event.touches[0].pageY : event.pageY;
      moveAt(pageX, pageY);
    };

    const onEnd = () => {
      const moveEvent = isTouchEvent ? "touchmove" : "mousemove";
      const endEvent = isTouchEvent ? "touchend" : "mouseup";

      document.removeEventListener(moveEvent, onMove);
      document.removeEventListener(endEvent, onEnd);
    };

    const moveEvent = isTouchEvent ? "touchmove" : "mousemove";
    const endEvent = isTouchEvent ? "touchend" : "mouseup";

    document.addEventListener(moveEvent, onMove);
    document.addEventListener(endEvent, onEnd);
  };

  // Attach both mouse and touch event listeners
  useEffect(() => {
    const popupHeader = popupHeaderRef.current; // Reference to the draggable header
    if (!popupHeader) return;

    popupHeader.addEventListener("mousedown", handleDrag);
    popupHeader.addEventListener("touchstart", handleDrag);

    // Cleanup listeners on unmount
    return () => {
      popupHeader.removeEventListener("mousedown", handleDrag);
      popupHeader.removeEventListener("touchstart", handleDrag);
    };
  }, []);


  // Handle user selecting a medicine
  const handleMedicineSelectMedicine = (e) => {
    const selectedMedId = e.target.value; // Selected Medicine ID
    const selectedMed = MedicineListItems.find(
      (med) => med.id.toString() === selectedMedId
    );

    if (selectedMed) {
      setSelectedMedicine(selectedMed);

      // Find the closest matching medicine type from dose_from
      const closestType = findClosestMatch(selectedMed.dose_from);
      setMediType(closestType); // Set the Medicine Type dropdown
    }
  };

  const closePopup = () => {
    setShowStickyPopup(false); // Hide the popup when close button is clicked
  };

  const renderDxTags = (dx) => {
    if (!dx) {
      // If dx is null, undefined, or an empty string, return null or an empty element
      return <span className="tag">No data</span>;
    }
    const tags = dx.split(", ");

    // Only show the first 3 tags, followed by "..." if there are more
    const displayedTags = tags.slice(0, 3).map((tag, index) => (
      <span key={index} className="tag">
        {tag}
      </span>
    ));

    return (
      <>
        {displayedTags}
        {tags.length > 3 && <span className="tag">...</span>}
      </>
    );
  };

  const fetchPatientHistory = async () => {
      const userInfo = localStorage.getItem('user-info');
      const parsedUserInfo = userInfo ? JSON.parse(userInfo) : null;
      if (parsedUserInfo && parsedUserInfo.doctor && parsedUserInfo.doctor.id) {
          try {
              const response = await axiosInstance.get(`/api/schedule-doctor/${parsedUserInfo.doctor.id}`);
              const doctorSchedule = response.data;

              if (doctorSchedule.length > 0) {
                  setAvailableDays(doctorSchedule.map(schedule => schedule.day));
              } else {
                  setAvailableDays([]);
              }
          } catch (error) {
              console.error('Error fetching doctor schedule:', error);
              setAvailableDays([]);
          }
      }
  };


  useEffect(() => {
    const userInfo = localStorage.getItem('user-info');
    const parsedUserInfo = userInfo ? JSON.parse(userInfo) : null;
    //console.log("lllllllllllllllllllllllll = ", parsedUserInfo.doctor.id)
    setParsedUserDoctorInfo(parsedUserInfo);
  }, {})

  useEffect(() => {
      if(!isDoctor()) {
        history('/dashboard'); // Redirect after successful creation
        return;
      }
      fetchPatientHistory();
      const queryParams = new URLSearchParams(window.location.search);
      const patient_mobile = queryParams.get('mobile');
      const appointment = queryParams.get('appointment');
      const p_name = queryParams.get('name');
      if(patient_mobile && p_name && appointment){
        setPatientValues({
          ...patientValues,
          mobile: patient_mobile,
          name: p_name,

        });
        setAppoinmentID(appointment);
        fetchPatientsByNumber(patient_mobile);
      }
  }, []);

  // Update the disabled days dynamically without re-initializing
  useEffect(() => {
      if (flatpickrInstance.current) {
          flatpickrInstance.current.set({
              disable: [
                  (date) => !availableDays.includes(date.toLocaleString('en-US', { weekday: 'long' })),
              ],
          });
      }
  }, [availableDays]);


  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };
  const reloadPage = () => {
    window.location.reload();
  }

  const handleMedSubmit = (e) => {
    e.preventDefault();
    if (mediType === '') {
      toast.error('Please select medicine type.', {
        autoClose: 3000,
      });
    }
    if (mediName === '') {
      toast.error('Please select medicine name.', {
        autoClose: 3000,
      });
    }

    //  else if (mediGenetic === '') {
    //   toast.error('Please enter medicine genetic.', {
    //     autoClose: 3000,
    //   });
    // }
     else if (mediType !== 'Fleet Enema' && mediStrength === '') {
      toast.error('Please enter medicine strength.', {
        autoClose: 3000,
      });
    }
     else if (mediType !== 'Tablet' && mediType !== 'Capsule'  && mediDosesPuffTime === '') {
      toast.error(`Please enter ${medicationPlaceholder}.`, {
        autoClose: 3000,
      });
    }

    else if (mediDays === '') {
      toast.error('Please enter days.', {
        autoClose: 3000,
      });
    }
    // else if (mediAdvice === '') {
    //   toast.error('Please enter medicine advice.', {
    //     autoClose: 3000,
    //   });
    // }
    else {
      // console.log(mediAdvices);
      let fullMedications = {
        medication_type: mediType,
        medication_name: mediName,
        medicine: mediId ? mediId : '',
        medication_schedule_monring: mediMoring,
        medication_schedule_afternoon: mediAfternoon,
        medication_schedule_evening: mediEvening,
        // medication_schedule_before_evening: beforeEvening,
        // medication_schedule_night: night,
        medication_with_meal: mediWithMeal,
        days: mediDays,
        advice: mediAdvice,
        // advice: mediAdvices.map((medadv) => medadv.value).join(', '),
        // genetic: mediGenetic,
        strength: mediStrength,
        dose_drops_time_puff: mediDosesPuffTime,
        mixture_details: mediMixture,
      };
      // console.log(fullMedications);
      setMedications([...medications, fullMedications]);
      setMediName('');
      setMediMoring('0');
      setMediAfternoon('0');
      setMediEvening('0');
      // setBeforeEvening('0');
      // setNight('0');
      setMediDays('');
      setMediAdvice('');
      setMediAdvices([]);
      // setMediGenetic('');
      setMediStrength('');
      setMediMixture('');
      setMediDosesPuffTime('');
    }
  };


  const handleMedicineSelect = (e) => {
    // console.log(e.target.value);
    setMedicationType(e.target.value);
    if (e.target.value === 'Drop') {
      setMediType('Drop');
      setMealChoice(false);
      setNebulization(false);
      setTablet(false);
      setMedicationPlaceholder(
        'Number of Drops (e.g. 2 drops per nostril/eye etc.)'
      );
    } else if (e.target.value === 'Fleet Enema') {
      setMediType('Fleet Enema');
      setMealChoice(false);
      setNebulization(false);
      setTablet(false);
      setMedicationPlaceholder('Times');
    } else if (e.target.value === 'Inhaler') {
      setMediType('Inhaler');
      setMealChoice(false);
      setNebulization(false);
      setTablet(false);
      setMedicationPlaceholder('Puffs (e.g. 2 puffs once daily.)');
    } else if (e.target.value === 'Injections') {
      setMediType('Injections');
      // setMealChoice(true);
      setMealChoice(false);
      setNebulization(false);
      setTablet(false);
      setMedicationPlaceholder(
        'e.g. 1 amp/vial 12 hourly, I/V, I/M, S/C at Things.'
      );
    } else if (e.target.value === 'Nasal Spray') {
      setMediType('Nasal Spray');
      setNebulization(false);
      setMealChoice(false);
      setTablet(false);
      setMedicationPlaceholder('e.g. Once spray per nose/both nose.');
    } else if (e.target.value === 'Nebulization') {
      setMediType('Nebulization');
      setNebulization(true);
      setMealChoice(false);
      setTablet(false);
      setMedicationPlaceholder('Number of times per days with period.');
    } else if (e.target.value === 'Powder') {
      setMediType('Powder');
      setMealChoice(false);
      setNebulization(false);
      setTablet(false);
      setMedicationPlaceholder(
        'Times per day (e.g. Once daily in affected area.)'
      );
    }
    else if (e.target.value === 'Cream') {
      setMediType('Cream');
      setMealChoice(false);
      setNebulization(false);
      setTablet(false);
      setMedicationPlaceholder(
        'Times per day (e.g. Once daily in affected area.)'
      );
    }
    else if (e.target.value === 'Ointments') {
      setMediType('Ointments');
      setMealChoice(false);
      setNebulization(false);
      setTablet(false);
      setMedicationPlaceholder(
        'Times per day (e.g. Once daily in affected area.)'
      );
    }else if (e.target.value === 'Suppository') {
      setMediType('Suppository');
      setMealChoice(false);
      setNebulization(false);
      setTablet(false);
      setMedicationPlaceholder(
        'Does with times (e.g. 1 stick per revtal, once daily.)'
      );
    } else if (e.target.value === 'Syrup') {
      setMediType('Syrup');
      setMealChoice(true);
      setNebulization(false);
      setTablet(false);
      setMedicationPlaceholder('Does with times (e.g. 2.5 tsf 3 times daily.)');
    } else if (e.target.value === 'Tablet') {
      setMediType('Tablet');
      setMealChoice(true);
      setNebulization(false);
      setTablet(true);
    }else if (e.target.value === 'Capsule') {
      setMediType('Capsule');
      setMealChoice(true);
      setNebulization(false);
      setTablet(true);
    } else {
      setMealChoice(false);
      setNebulization(false);
      setTablet(false);
      setMedicationPlaceholder(
        'Number of Drops (e.g. 2 drops per nostril/eye etc.)'
      );
    }
  };

  const handleMedicineSelectUpdated = (mt) => {
    // console.log(e.target.value);
    setMedicationType(mt);
    if (mt === 'Drop') {
      setMediType('Drop');
      setMealChoice(false);
      setNebulization(false);
      setTablet(false);
      setMedicationPlaceholder(
        'Number of Drops (e.g. 2 drops per nostril/eye etc.)'
      );
    } else if (mt === 'Fleet Enema') {
      setMediType('Fleet Enema');
      setMealChoice(false);
      setNebulization(false);
      setTablet(false);
      setMedicationPlaceholder('Times');
    } else if (mt === 'Inhaler') {
      setMediType('Inhaler');
      setMealChoice(false);
      setNebulization(false);
      setTablet(false);
      setMedicationPlaceholder('Puffs (e.g. 2 puffs once daily.)');
    } else if (mt === 'Injections') {
      setMediType('Injections');
      // setMealChoice(true);
      setMealChoice(false);
      setNebulization(false);
      setTablet(false);
      setMedicationPlaceholder(
        'e.g. 1 amp/vial 12 hourly, I/V, I/M, S/C at Things.'
      );
    } else if (mt === 'Nasal Spray') {
      setMediType('Nasal Spray');
      setNebulization(false);
      setMealChoice(false);
      setTablet(false);
      setMedicationPlaceholder('e.g. Once spray per nose/both nose.');
    } else if (mt === 'Nebulization') {
      setMediType('Nebulization');
      setNebulization(true);
      setMealChoice(false);
      setTablet(false);
      setMedicationPlaceholder('Number of times per days with period.');
    } else if (mt === 'Powder') {
      setMediType('Powder');
      setMealChoice(false);
      setNebulization(false);
      setTablet(false);
      setMedicationPlaceholder(
        'Times per day (e.g. Once daily in affected area.)'
      );
    }
    else if (mt === 'Cream') {
      setMediType('Cream');
      setMealChoice(false);
      setNebulization(false);
      setTablet(false);
      setMedicationPlaceholder(
        'Times per day (e.g. Once daily in affected area.)'
      );
    }
    else if (mt === 'Ointments') {
      setMediType('Ointments');
      setMealChoice(false);
      setNebulization(false);
      setTablet(false);
      setMedicationPlaceholder(
        'Times per day (e.g. Once daily in affected area.)'
      );
    }else if (mt === 'Suppository') {
      setMediType('Suppository');
      setMealChoice(false);
      setNebulization(false);
      setTablet(false);
      setMedicationPlaceholder(
        'Does with times (e.g. 1 stick per revtal, once daily.)'
      );
    } else if (mt === 'Syrup') {
      setMediType('Syrup');
      setMealChoice(true);
      setNebulization(false);
      setTablet(false);
      setMedicationPlaceholder('Does with times (e.g. 2.5 tsf 3 times daily.)');
    } else if (mt === 'Tablet') {
      setMediType('Tablet');
      setMealChoice(true);
      setNebulization(false);
      setTablet(true);
    }else if (mt === 'Capsule') {
      setMediType('Capsule');
      setMealChoice(true);
      setNebulization(false);
      setTablet(true);
    }
    // else if (mt === 'all') {
    //   setMealChoice(true);
    //   setNebulization(true);
    //   setTablet(true);
    // }
    else {
      setMealChoice(false);
      setNebulization(false);
      setTablet(false);
      setMedicationPlaceholder(
        'Number of Drops (e.g. 2 drops per nostril/eye etc.)'
      );
    }
  };


  const handleMedicineType = (type) => {
    setMediType(type); // Use setMediType here
    handleMedicineSelectUpdated(type)
  };

  const deleteMedication = (index) => {
    // console.log(index);
    setMedications(
      medications.filter((medication) => medication.medication_name !== index)
    );
  };

  const handleDeleteMedication = (medication_name) => {
    // let v = confirm("Are you sure to remove this?");
    if (window.confirm("Are you sure to remove this?")) {
      deleteMedication(medication_name)
    }
  }
  //finish for medicien info

  const [formValues, setFormValues] = useState({
    token: Math.floor(Math.random() * 100000 + 10),
    doctor: '',
    patient: '',
    examination: `B. Pressure (mmHg): \nPulse (bpm): \nTemperature (°F): \nRBS/Blood Suger: \nSPO2: \nOthers: `,
    chief_complaint: '',
    relevant_history: '',
    investigations: '',
    advice: '',
    height: '',
    weight: '',
    followup_date: '',
  });

  //'patient','dx','token','symptoms','signs','investigations','medications','advice','followup_date', 'doctor'
  const [patientValues, setPatientValues] = useState({
    name: '',
    mobile: '',
    age: 0,
    gender: '',
    dob: '',
    // height: '',
    // weight: '',
    marital_status: '',
    occupation: '',
    address_district: '',
    address_thana: '',
  });


  const fetchPatientsByNumber = async (mobileNumber) => {
      if (mobileNumber.length >= 10) {
          try {
              const response = await axiosInstance.get(`${process.env.REACT_APP_AXIOS_BASE_URL}/api/patient_by_mobile/${mobileNumber}`);
              if (response.data.status === 1 && response.data.data.length > 0) {
                  setPatients(response.data.data);
                  setPatientNotFound(false);
              } else {
                  setPatients([]);
                  setPatientNotFound(true);
              }
          } catch (error) {
              console.error('Error fetching patients:', error);
              setPatientNotFound(true);
          }
      } else {
          setPatients([]);
          setPatientNotFound(false);
      }
  };



  //'gender', 'age', 'age_type', 'marital_status','occupation','name','mobile','dob','address_district','doctor','address_thana', 'token'

  // patient exist or not

  const handleMobileBlur = async () => {
    const patientMobile = patientValues.mobile.trim(); // Ensure mobile number is clean
    const patientName = patientValues.name.trim(); // Ensure name is clean

    if (patientMobile) {
      if (patientMobile.length === 11) {
        try {
          const response = await axiosInstance.get(
            `${process.env.REACT_APP_AXIOS_BASE_URL}/api/patient_by_confirm_both/${patientMobile}/${patientName}/`
          );
          if (response.data.status === 1) {
            setShowStickyPopup(true);
            // Patient exists, disable input fields and populate data
            setPatientValues({
              ...patientValues,
              name: response.data.data.name,
              age: response.data.data.age,
              dob: response.data.data.dob,
              gender: response.data.data.gender,
              marital_status: response.data.data.marital_status,
              occupation: response.data.data.occupation,
              address_district: response.data.data.address_district,
              address_thana: response.data.data.address_thana,
            });
            setFormValues((prevValues) => ({
              ...prevValues,
              patient: response.data.data.id, // Set patient ID
            }));
            setPatientExists(true); // Indicate that patient exists
            if (weightInputRef.current) {
              weightInputRef.current.focus();
            }

            try {
              // 1. Parent API call (prescription API)
              const prescriptionResponse = await axiosInstance.get(
                `${process.env.REACT_APP_AXIOS_BASE_URL}/api/prescription_by_patient_full/${response.data.data.id}/`
              );

              if (prescriptionResponse.data) {
                const updatedPrescriptions = await Promise.all(
                  prescriptionResponse.data.map(async (prescription) => {
                    try {
                      const orderResponse = await axiosAmarlabInstance.get(
                        '/order/sneho-order-tree/',
                        {
                          params: {
                            from_sneho: 1,
                            sneho_prescription_id: prescription.id,
                          },
                        }
                      );
                      prescription.diagnostic =
                        orderResponse.data?.results || [];
                    } catch (error) {
                      prescription.diagnostic = [];
                    }
                    return prescription;
                  })
                );

                setPrescriptions(updatedPrescriptions); // Update state with enriched data
              } else {
                setPrescriptions([]); // Set empty prescriptions if no data
              }
            } catch (error) {
              console.error('Error fetching prescription data:', error);
              setPrescriptions([]); // Set empty prescriptions on error
            }

          } else {
            // Patient does not exist, keep fields enabled for input
            setPatientExists(false);
            setShowStickyPopup(false);
          }
        } catch (error) {
          console.error('Error fetching patient data:', error);
        }
      } else {
        // Handle invalid mobile number (e.g., show an error message)
        toast.error('Please enter a valid 11-digit mobile number.');
        return;
      }
    } else {
      setPatientExists(false);
      setShowStickyPopup(false);
    }
  };

  // const handleMobileBlur = async () => {
  //   const patientMobile = patientValues.mobile.trim();  // Ensure mobile number is clean
  //   const patientName = patientValues.name.trim();  // Ensure mobile number is clean
  //   if(patientMobile) {
  //     if (patientMobile.length === 11) {
  //       try {
  //         const response = await axiosInstance.get(`${process.env.REACT_APP_AXIOS_BASE_URL}/api/patient_by_confirm_both/${patientMobile}/${patientName}/`);
  //         if (response.data.status === 1) {
  //           setShowStickyPopup(true)
  //           // Patient exists, disable input fields and populate data
  //           setPatientValues({
  //             ...patientValues,
  //             name: response.data.data.name,
  //             age: response.data.data.age,
  //             dob: response.data.data.dob,
  //             gender: response.data.data.gender,
  //             marital_status: response.data.data.marital_status,
  //             occupation: response.data.data.occupation,
  //             address_district: response.data.data.address_district,
  //             address_thana: response.data.data.address_thana,
  //           });
  //           setFormValues((prevValues) => ({
  //             ...prevValues,
  //             patient: response.data.data.id, // Set patient ID
  //           }));
  //           setPatientExists(true);  // Indicate that patient exists
  //           if (weightInputRef.current) {
  //              weightInputRef.current.focus();
  //            }
  //
  //
  //              try {
  //                // 1. Parent API call (prescription API)
  //                const prescriptionResponse = await axiosInstance.get(
  //                  `${process.env.REACT_APP_AXIOS_BASE_URL}/api/prescription_by_patient_full/${response.data.data.id}/` // Replace somePatientId with the actual patient ID
  //                );
  //
  //                if (prescriptionResponse.data) {
  //                  prescriptionResponse.data.forEach((prescription, index) => {
  //                    axiosAmarlabInstance.get('/order/sneho-order-tree/', {
  //                      params: {
  //                        from_sneho: 1,
  //                        sneho_prescription_id: prescription.id,
  //                      },
  //                    })
  //                    .then(orderResponse => {
  //                      if (orderResponse.data && orderResponse.data.results) {
  //                        prescription.diagnostic = orderResponse.data.results || [];
  //                      }
  //                    })
  //                    .catch(error => {
  //                      prescription.diagnostic = [];
  //                      //console.error('Error fetching order data:', error);
  //                    });
  //                  });
  //
  //                  // Update prescription data with potentially enriched diagnostic
  //                  console.log("the prescription data is  = ", prescriptionResponse.data);
  //                  setPrescriptions(prescriptionResponse.data);
  //                } else {
  //                  setPrescriptions([]); // Set empty prescriptions if no data
  //                }
  //              } catch (error) {
  //                console.error('Error fetching data:', error.response || error);
  //                setPrescriptions([]); // Set empty prescriptions on error
  //              }
  //
  //
  //                // Fetch prescriptions for the patient
  //                // const prescriptionResponse = await axiosInstance.get(
  //                //   `${process.env.REACT_APP_AXIOS_BASE_URL}/api/prescription_by_patient_full/${response.data.data.id}/`
  //                // );
  //                // if (prescriptionResponse.data) {
  //                //   console.log("Ttttttttttthhhhhheeeeee data = ", prescriptionResponse.data)
  //                //   // Set prescriptions data to state
  //                //   setPrescriptions(prescriptionResponse.data); // Update state with prescriptions
  //                // } else {
  //                //   setPrescriptions([]); // No prescriptions available
  //                // }
  //
  //
  //         } else {
  //           // Patient does not exist, keep fields enabled for input
  //           setPatientExists(false);
  //           setShowStickyPopup(false);
  //         }
  //       } catch (error) {
  //         console.error('Error fetching patient data:', error);
  //
  //       }
  //     } else {
  //       // Handle invalid mobile number (e.g., show an error message)
  //       toast.error('Please enter a valid 11-digit mobile number.');
  //       return;
  //     }
  //   } else {
  //     setPatientExists(false);
  //     setShowStickyPopup(false)
  //   }
  //
  // };

  //patient existence finish


  // Function to calculate Date of Birth from Age
  const calculateDOB = (age) => {
    const currentDate = moment();
    const dob = currentDate.subtract(age, 'years').format('YYYY-MM-DD'); // Format as 'YYYY-MM-DD'
    return dob;
  };

  // Function to calculate Age from Date of Birth
  const calculateAge = (dob) => {
    const currentDate = moment();
    const birthDate = moment(dob, 'YYYY-MM-DD');
    const age = currentDate.diff(birthDate, 'years');
    return age;
  };

  // Handler for Age Input
  const handleAgeChange = (e) => {
    const { value } = e.target;
    const age = value ? parseFloat(value) : ''; // Use parseFloat for decimals

    setPatientValues((prevValues) => ({
      ...prevValues,
      age: age,
      dob: age ? calculateDOB(age) : '', // Auto-update DOB
    }));
  };
  // Handler for DOB Input
  const handleDOBChange = (e) => {
    const { value } = e.target;

    setPatientValues((prevValues) => ({
      ...prevValues,
      dob: value,
      age: value ? calculateAge(value) : '', // Auto-update Age
    }));
  };



  // // Function to calculate dob from age
  // const calculateDOB = (age) => {
  //   // Get the current date
  //   const currentDate = moment();
  //
  //   // Subtract the age from the current year to calculate the birth year
  //   const dob = currentDate.subtract(age, 'years').format('YYYY-MM-DD'); // Format as 'YYYY-MM-DD'
  //
  //   return dob;
  // };


  // define post request functions.......
  // src/components/CreatePrescription.js

  const createPatient = async (patientValues) => {
    try {
      // Fetch doctor information from localStorage
      const userInfo = localStorage.getItem('user-info');
      const parsedUserInfo = userInfo ? JSON.parse(userInfo) : null;

      if (!parsedUserInfo || !parsedUserInfo.doctor) {
        throw new Error("Doctor information not found in please logged in again");
      }
      // Calculate the dob based on the age provided
      const dob = calculateDOB(patientValues.age);



      // Add age_type and doctor fields to patient values
      const updatedPatientValues = {
        ...patientValues,
        age_type: 'year', // Set age_type to 'year'
        doctor: parsedUserInfo.doctor.id, // Get doctor ID from localStorage
        dob, // Set the calculated dob
      };

      // Send the POST request to create a new patient
      //const response = await axiosInstance.post('/api/patient/', updatedPatientValues);

      const response = await toast.promise(
          axiosInstance.post('/api/patient/', updatedPatientValues),
          {
            loading: 'Creating patient...',
            success: <b>Patient has been added to our system!</b>,
            error: <b>Failed to adding patient.</b>,
          }
      );



      if(response && response.data && response.data.id){
        setPatientExists(true)
        //toast.success("Patient created successfully!");
        console.log(response.data.id);
      } else {
        setPatientExists(false)
        toast.error("Something went wrong, when adding patient, please try again!")
        return;
      }

      return response.data.id;
    } catch (error) {
      console.error("Error creating patient:", error);
      toast.error("Error creating patient. Please try again.");
      console.log(patientValues);
      throw error;
    }
  };



  const [isStepValid, setIsStepValid] = useState(false);

  // Function to handle navigation between steps
  const nextStep = () => setStep(step + 1);
  const prevStep = () => setStep(step - 1);
  const nextStepPatient = async () => {
    if(!formValues.patient || !patientExists){
      try {

        // if (!patientValues.mobile) {
        //   toast.error('Patient mobile is required.');
        //   return;
        // }

        if (!patientValues.name) {
          toast.error("Patient name is required.")
          return;
        }

        if (!patientValues.age) {
          toast.error('Patient age is required.');
          return;
        }
        if (isNaN(patientValues.age)) {
          toast.error('Patient age must be a valid number.');
          return;
        }

        if (!patientValues.gender) {
          toast.error('Patient gender is required.');
          return;
        }
        if (!patientValues.marital_status) {
          toast.error('Patient marital status is required.');
          return;
        }

        // Create patient and get the patient id
        const patientId = await createPatient(patientValues);
        // Update formValues with the returned patient id
        setFormValues((prevValues) => ({
          ...prevValues,
          patient: patientId, // Set patient ID
        }));

        //alert("Patient created and ID set successfully!");
        setStep(step + 1); // Move to the next step or modify as needed
      } catch (error) {
        toast.error("Have a error, please re-check patient details.")
        console.error("Error in nextStepPatient:", error);
      }
    } else {
      setStep(step + 1); // Move to the next step or modify as needed
    }

  };





  const SavePrescription = async () => {
    try {
      // Get the doctor ID from localStorage
      const doctorData = JSON.parse(localStorage.getItem("user-info"));
      const doctorId = doctorData?.doctor?.id; // Extract doctor ID

      if (!doctorId || !formValues.patient) {
        toast.error("Doctor ID or Patient ID is missing.");
        return;
      }

      // Update the formValues with doctor ID and patient ID
      const prescriptionData = {
        ...formValues,
        doctor: doctorId,  // Add doctor ID
        followup_date: formValues.followup_date ? formValues.followup_date : null,
        investigations: formValues.investigations && formValues.investigations.length > 0
            ? formValues.investigations.map((item) => item.value).join(', ')
            : null,  // Set to null if no investigations are selected
        advice: formValues.advice && formValues.advice.length > 0
            ? formValues.advice.map((item) => item.value).join(', ')
            : null,  // Set to null if no advice is selected

        // Process the examination field
        examination: formValues.examination
          ? formValues.examination
              .split('\n') // Split into lines
              .map((line) => line.trim()) // Trim each line
              .filter((line) => line.includes(':') && line.split(':')[1].trim().length > 0) // Keep only lines with meaningful content after ':'
              .join(', ') // Join with commas
          : null, // Set to null if examination is empty
      };

      console.log("Submitting Prescription Data: ", prescriptionData.examination);
      //return;

      // Step 1: Make POST request to save prescription
      //const response = await axiosInstance.post('/api/prescription/', prescriptionData);

      const response = await toast.promise(
          axiosInstance.post('/api/prescription/', prescriptionData),
          {
            loading: 'Creating prescription...',
            success: <b>Prescription created successfully!</b>,
            error: <b>Failed to updating prescription.</b>,
          }
      );


      if (response.status === 201) {
        const prescriptionId = response.data.id; // Get the created prescription ID
        setLastPrescriptionId(response.data.id);
        setIsSubmitted(true); // Set to true to hide the form
        setStep(step + 1);
        if(prescriptionId){
          setShowStickyPopup(false);
          //toast.success("Prescription saved successfully!");
          setCountPrescription(prescriptionId);
          if(appoinmentID && appoinmentID > 0){
            const appoinmentUpdateResponse = await axiosInstance.get(`/api/appoinment-status-update/${appoinmentID}/${prescriptionId}`);
            console.log("Appoinment Update", appoinmentUpdateResponse);
          }

        } else {
          toast.error("Something went wrong, please check and create again.");
          return;
        }
        // Step 2: Check if there are medications to save
        if (medications.length > 0) {
          const postMedications = (presId) => {
            return medications.map((medication) => ({
              ...medication,
              prescription: presId,
              doctor: doctorId,
            }));
          };

          try {
            // Step 3: Make POST request to save medications
            const medicationResponse = await axiosInstance.post(
              '/api/medication_entry/',
              postMedications(prescriptionId)
            );

            if (medicationResponse.status === 201) {
              toast.success("Medications saved successfully!");
            } else {
              toast.error("Failed to save medications.");
            }
          } catch (error) {
            console.error("Error saving medications: ", error);
            toast.error("An error occurred while saving the medications.");
          }
        }
      } else {
        toast.error("Failed to save prescription.");
      }
    } catch (error) {
      console.error("Error saving prescription: ", error);
      toast.error("An error occurred while saving the prescription.");
    }
  };


  const fetchDataInvest = async (inputValue) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_AMARLAB_API}/diagnostic/diagnostic-test/?limit=20&search=${inputValue}`);
      const data = await response.json();
      setInvestigations(data.results.map(item => ({ value: item.name, label: item.name })));
      // Return transformed options for AsyncCreatableSelect
      return data.results.map(item => ({ value: item.name, label: item.name }));
    } catch (error) {
      console.error('Error fetching investigations:', error);
      return []; // Return empty array in case of error
    }
  };

  const fetchDataAdvice = async (inputValue) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_AXIOS_BASE_URL}/api/v2/advice/?limit=20&search=${inputValue}`);
      const data = await response.json();

      // Return the mapped options directly
      return data.results.map(item => ({ value: item.name, label: item.name }));
    } catch (error) {
      console.error('Error fetching advices:', error);
      return []; // Return empty array in case of error
    }
  };

  // Fetch investigations and advice using useEffect
  useEffect(() => {
    // const fetchDataInvest = async (inputValue) => {
    //   try {
    //     const response = await fetch(`${process.env.REACT_APP_AMARLAB_API}/diagnostic/diagnostic-test/?limit=300&search=${inputValue}`);
    //     const data = await response.json();
    //     setInvestigations(data.results.map(item => ({ value: item.name, label: item.name })));
    //   } catch (error) {
    //     console.error('Error fetching investigations:', error);
    //   }
    // };

    // const fetchDataAdvice = async () => {
    //   try {
    //     const response = await fetch(`${process.env.REACT_APP_AXIOS_BASE_URL}/api/v2/advice/?limit=200`);
    //     const data = await response.json();
    //     setAdvices(data.results.map(item => ({ value: item.name, label: item.name })));
    //   } catch (error) {
    //     console.error('Error fetching advices:', error);
    //   }
    // };

    fetchDataInvest();
    fetchDataAdvice();
  }, []);

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
    if (name === 'followup_date') {
        const selectedDate = value;
        const selectedDay = new Date(selectedDate).toLocaleString('en-US', { weekday: 'long' });

        // if schedule not needed then this code will be removed
        if (availableDays.includes(selectedDay)) {
            // Valid day, update followup_date and clear error
            setFormValues((prevValues) => ({ ...prevValues, followup_date: selectedDate }));
            setError('');
        } else {
            // Invalid day, clear followup_date and set error message
            setFormValues((prevValues) => ({ ...prevValues, followup_date: '' }));
            toast.error(`Selected date is not available. Please choose a ${availableDays.join(', ')}, or change your schedule from your profile.`)
            setError(`Selected date is not available. Please choose a ${availableDays.join(', ')}`);
        }
        //finish this code will removed when schedule not needed
    }
  };

  const handlePatientChange = (e) => {
    const { name, value } = e.target;
    setPatientValues({ ...patientValues, [name]: value });
    if (name === 'mobile') {
        fetchPatientsByNumber(value);
    }
    if (name === 'address_district') {
      setAvailableThanas(thanasByDistrict[value] || []); // Get thanas for the selected district
    }
  };

  const formatId = (id) => {
    // Pad ID with leading zeros to ensure 5 digits
    return id.toString().padStart(5, '0');
  };
  // Fetch patient history data with pagination and filtering
  const fetchPrescriptionCounter = async () => {
    try {
      const response = await axiosInstance.get(`/api/prescription-count/`);
      setCountPrescription(response.data.next_id); // Assuming the API returns a `results` array
    } catch (error) {
      console.error('Error fetching patient history:', error);
    }
  };

  useEffect(() => {
    fetchPrescriptionCounter();
  }, []);


  // Validate step 1
  useEffect(() => {
    if (step === 1) {
      const isValid = patientValues.name && patientValues.mobile && patientValues.gender && patientValues.marital_status;
      setIsStepValid(isValid);
    } else if (step === 2) {
      const isValid = patientValues.address_district && patientValues.address_thana;
      setIsStepValid(isValid);
    } else if (step === 3) {
      const isValid = formValues.dx && formValues.symptoms && formValues.investigations;
      setIsStepValid(isValid);
    }
  }, [patientValues, formValues, step]);





  return (
    <div className="dashboard-container ">
      <Sidebar /> {/* Sidebar component */}
      <div className="dashboard-main">
        <Header /> {/* Header component */}

        <div className="content-box create-prescription">
          <div className="content-center">
            <h4 className="prescription-ids">Prescription ID - #{formatId(countPrescription)}</h4>
            {/* Step Navigation */}
            <div className="step-navigation">
              <div className={`step ${step === 1 || step === 2 || step === 3 || step === 4 ? 'active' : ''}`}>
                <span className="circle">1</span>
              </div>
              <div className={`step ${step === 2 || step === 3 || step === 4 ? 'line active' : 'line'}`}></div>
              <div className={`step ${step === 2 || step === 3 || step === 4 ? 'active' : ''}`}>
                <span className="circle">2</span>
              </div>
              <div className={`step ${step === 3 || step === 4 ? 'active line' : 'line'}`}></div>
              <div className={`step ${step === 3 || step === 4 ? 'active' : ''}`}>
                <span className="circle">3</span>
              </div>
              <div className={`step ${step === 4 ? 'active line' : 'line'}`}></div>
              <div className={`step ${step === 4 ? 'active' : ''}`}>
                <span className="circle">4</span>
              </div>
            </div>

            {/* Step 1 - Patient Information Form */}
            {step === 1 && (
              <div className="form-step">
                <h2>Patient Information</h2>
                <form>
                  <div className="form-group">
                    <input type="text" name="mobile" placeholder="Enter Mobile Number (Prescription Will sent throuh SMS)"  pattern="[0-9]{11}" title="Please enter a valid 11-digit Bangladeshi mobile number starting with 01."  value={patientValues.mobile} onChange={handlePatientChange} required />
                    <label>Mobile Number </label>
                  </div>
                  <div className="form-group">
                    <input type="text" name="name" list="patientNames"  placeholder="Enter Patient's Full Name" onBlur={handleMobileBlur} value={patientValues.name} onChange={handlePatientChange} required />
                    <label>Full Name <sup>*</sup></label>
                     <datalist id="patientNames">
                         {patients.map((patient) => (
                             <option key={patient.name} value={patient.name}>
                                 {patient.name}
                             </option>
                         ))}
                     </datalist>
                  </div>
                  {/*
                  <div className="form-row">
                    <div className="form-group left">
                      <input type="number" name="age" placeholder="Enter Age" disabled={patientExists}  value={patientValues.age} onChange={handlePatientChange} required />
                      <label>Age (year)<sup>*</sup></label>
                    </div>
                    <div className="form-group half right">
                      <select name="gender" disabled={patientExists} placeholder="Select Gender" value={patientValues.gender} onChange={handlePatientChange} required>
                        <option value="" selected>Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Common">Other</option>
                      </select>
                      <label>Gender <sup>*</sup></label>
                    </div>
                  </div>
                  */}
                  <div className="form-row">
                    {/* Age Field */}
                    <div class="half left dob-age">
                      <div className="form-group age">
                        <input
                          type="number"
                          name="age"
                          placeholder="Enter Age"
                          disabled={patientExists}
                          value={patientValues.age}
                          onChange={handleAgeChange} // New handler for age
                          step="0.1" // Allows 0.1 increments (e.g., 0.1, 0.5, 1.2)
                          required
                        />
                        <label>Age (year)<sup>*</sup></label>
                      </div>

                      {/* Date of Birth Field */}
                      <div className="form-group half left dob">
                        <input
                          type="date"
                          name="dob"
                          placeholder="Enter Date of Birth"
                          disabled={patientExists}
                          value={patientValues.dob || ''}
                          onChange={handleDOBChange} // New handler for DOB
                          required
                        />
                        <label>Date of Birth<sup>*</sup></label>
                      </div>
                    </div>

                    {/* Gender Field */}
                    <div className="form-group half right">
                      <select
                        name="gender"
                        disabled={patientExists}
                        value={patientValues.gender}
                        onChange={handlePatientChange}
                        required
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Common">Other</option>
                      </select>
                      <label>Gender <sup>*</sup></label>
                    </div>
                  </div>

                  {/* <div className="form-row">
                    <div className="form-group">
                      <input type="number" name="height" placeholder="Enter Height" value={formValues.height} onChange={handlePatientChange} required />
                      <label>Height</label>
                    </div>
                    <div className="form-group weight  half right">
                      <input type="number" name="weight" placeholder="Enter Weight" value={formValues.weight} onChange={handlePatientChange} required />
                      <label>Weight</label>
                    </div>
                  </div> */}

                  <div className="form-row">
                    <div className="form-group marital">
                      <select name="marital_status" placeholder="Select Marital Status" disabled={patientExists} value={patientValues.marital_status} onChange={handlePatientChange} required>
                        <option value="" selected>Select Marital Status</option>
                        <option value="Single">Single</option>
                        <option value="Married">Married</option>
                        <option value="Divorced">Divorced</option>
                        <option value="Widowed">Widowed</option>
                        <option value="Separated">Separated</option>
                      </select>
                      <label>Marital Status <sup>*</sup></label>
                    </div>
                    <div className="form-group occupation">
                      <input type="text" name="occupation" placeholder="Select Occupation" disabled={patientExists} value={patientValues.occupation} onChange={handlePatientChange} required />
                      <label>Occupation</label>
                    </div>
                  </div>
                  <h4 className="prescription-sub-title">Address</h4>
                  <div className="form-row prescription-address marital">
                    <div className="form-group">
                      <select
                        name="address_district"
                        value={patientValues.address_district}
                        onChange={handlePatientChange}
                        disabled={patientExists}
                        required
                      >
                        <option value="">Select District</option>
                        {districts.map((district) => (
                          <option key={district.name} value={district.name}>
                            {district.name}
                          </option>
                        ))}
                      </select>
                      <label>District</label>
                    </div>

                    <div className="form-group half right">
                      <select
                        name="address_thana"
                        value={patientValues.address_thana}
                        onChange={handlePatientChange}
                        disabled={patientExists}
                        required
                      >
                        <option value="">Select Thana</option>
                        {availableThanas.map((thana) => (
                          <option key={thana} value={thana}>
                            {thana}
                          </option>
                        ))}
                      </select>
                      <label>Thana </label>
                    </div>
                  </div>

                  <h4 className="prescription-sub-title">Other's Information  </h4>
                  <div className="form-row prescription-address marital">
                    <div className="form-group half left">
                      <input type="number" min="0" max="1000" step="0.1" name="height" className="height" placeholder="Enter Height" value={formValues.height} onChange={handleInputChange} />
                      <label>Height (Feet)</label>
                    </div>

                    <div className="form-group half right">
                      <input type="number" ref={weightInputRef} min="0" max="1000" step="0.1"  name="weight" className="weight" placeholder="Enter Weight" value={formValues.weight} onChange={handleInputChange} />
                      <label>Weight (KG) </label>
                    </div>
                  </div>
                  <button type="button" className="next-single" onClick={nextStepPatient}>Next</button>
                </form>
              </div>
            )}



            {/* Step 2 - History */}
            {step === 2 && (
              <div className="form-step">
                <h2>Medical History</h2>
                <form>
                  {/* Medical Information fields */}
                 <h4 className="prescription-sub-title">Chief Complaint</h4>
                  <div className="form-group history">
                  <textarea name="chief_complaint"
                    value={formValues.chief_complaint}
                    maxLength="999"
                    onChange={handleInputChange} placeholder="Enter Chief Complaint">
                    </textarea>
                    <label>Add Chief Complaint (comma separated)</label>
                  </div>
                  <h4 className="prescription-sub-title">Relevant History</h4>
                  <div className="form-group history">
                    <textarea name="relevant_history"
                    maxLength="999"
                    value={formValues.relevant_history}
                    onChange={handleInputChange} placeholder="Enter Relevant History">
                    </textarea>
                    <label>Relevant History (comma separated)</label>
                  </div>

                  <h4 className="prescription-sub-title">On Examination</h4>
                  <div className="form-group history">
                  <textarea name="examination"
                    value={formValues.examination}
                    maxLength="999"
                    style={{
                    height: '110px',
                    }}
                    onChange={handleInputChange} placeholder="Enter On Examination">
                    </textarea>
                    <label>On Examination (comma separated)</label>
                  </div>
                  <h4 className="prescription-sub-title">Investigations</h4>
                  <div className="form-group">
                      <AsyncCreatableSelect
                          isMulti
                          cacheOptions
                          loadOptions={fetchDataInvest}  // Pass the fetch function
                          defaultOptions  // This allows initial data to be loaded
                          value={formValues.investigations} // Set the selected values
                          onChange={(selectedInvestigations) => {
                              // Store selected investigations as an array of objects with label and value
                              setFormValues((prevValues) => ({
                                  ...prevValues,
                                  investigations: selectedInvestigations || [], // Ensure it's an array, even if empty
                              }));
                              console.log("Selected investigations:", selectedInvestigations);
                          }}
                      />
                    <label>Investigations </label>
                  </div>
                  <button type="button" className="prev" onClick={prevStep}>Previous</button>
                  <button type="button" className="next" onClick={nextStep}>Next</button>
                </form>
              </div>
            )}

            {/* Step 3 - Medical Information Form */}
            {step === 3 && (
              <div className="form-step">
              {/* Tab Navigation */}
                <div className="tabs-prescription">
                  <div
                    className={`tab-button-prescription ${activeTab === 'treatment' ? 'active' : ''}`}
                    onClick={() => handleTabChange('treatment')}
                  >
                    Treatment
                  </div>
                  <div
                    className={`tab-button-prescription ${activeTab === 'advice' ? 'active' : ''}`}
                    onClick={() => handleTabChange('advice')}
                  >
                    Advice
                  </div>
                </div>

          {/* Tab Content */}
          {activeTab === 'treatment' && (
            <div className="tab-content">
                <form>
                {/*
                <div className='form-group medicine-type'>
                  <select
                    className='form-control form-control-lg'
                    onChange={handleMedicineSelect}
                    value={mediType}
                  >
                    <option value='' selected>Select Medicine Type</option>
                    <option value='Drop'>Drop</option>
                    <option value='Fleet Enema'>Fleet Enema</option>
                    <option value='Inhaler'>Inhaler</option>
                    <option value='Injections'>Injections</option>
                    <option value='Nasal Spray'>Nasal Spray</option>
                    <option value='Nebulization'>Nebulization</option>
                    <option value='Powder'>Powder</option>
                    <option value='Cream'>Cream</option>
                    <option value='Ointments'>Ointments</option>
                    <option value='Suppository'>Suppository</option>
                    <option value='Syrup'>Syrup</option>
                    <option value='Tablet'>Tablet</option>
                    <option value='Capsule'>Capsule</option>
                  </select>
                  <label>Medicine Type</label>
                </div>
                */}

                <div class="mst">
                  <MedicineList
                    setMedName={setMediName}
                    setMedid={setMediId}
                    setMediStrength={setMediStrength}
                    setMediType={handleMedicineType} // Pass setMediType callback here
                    medListItems={MedicineListItems}
                  />
                </div>


                  {/*
                    {medicationType !== 'Fleet Enema' && medicationType !== '' && (
                      <div className='form-group'>
                        <input
                          type='text'
                          className='form-control form-control-lg'
                          placeholder="Strength (mg)"
                          value={mediStrength || ''}
                          onChange={(e) => setMediStrength(e.target.value)}
                        />
                        <label>Strength</label>
                      </div>
                    )}
                  */}

                    {nebulization && (
                      <div className='form-group'>
                        <input
                          type='text'
                          className='form-control form-control-lg'
                          placeholder="Mixture Details"
                          value={mediMixture || ''}
                          onChange={(e) => setMediMixture(e.target.value)}
                        />
                        <label>Mixture</label>
                      </div>
                    )}

                  <div className="dose-full">
                   <div className="dose-three">
                   {tablet && (
                      <>
                        <div className='form-group dose'>
                            <select
                              className='form-control form-control-lg number_of_dose'
                              onChange={(e) => setMediMoring(e.target.value)}
                              value={mediMoring}
                            >
                              <option value='0'>00</option>
                              <option value='1'>01</option>
                              <option value='2'>02</option>
                            </select>
                            <label>Morning</label>
                        </div>
                        <div className='form-group dose'>
                          <select
                            className='form-control form-control-lg number_of_dose'
                            onChange={(e) => setMediAfternoon(e.target.value)}
                            value={mediAfternoon}
                          >
                            <option value='0'>00</option>
                            <option value='1'>01</option>
                            <option value='2'>02</option>
                          </select>
                          <label>Afternoon</label>
                        </div>
                        <div className='form-group dose'>
                          <select
                            className='form-control form-control-lg number_of_dose'
                            onChange={(e) => setMediEvening(e.target.value)}
                            value={mediEvening}
                          >
                            <option value='0'>00</option>
                            <option value='1'>01</option>
                            <option value='2'>02</option>
                          </select>
                          <label>Evening</label>
                        </div>
                      </>

                    )}
                    </div>
                  </div>
                    {!tablet && medicationType !== '' && (
                      <div className='form-group'>
                        <input
                          type='text'
                          className='form-control form-control-lg'
                          placeholder={medicationPlaceholder}
                          value={mediDosesPuffTime}
                          onChange={(e) => setMediDosesPuffTime(e.target.value)}
                        />
                          <label>{medicationPlaceholder}</label>
                      </div>
                    )}


                      {medicationType !== '' && (
                        <div className='form-group'>
                          <input
                            type='number'
                            className='form-control form-control-lg'
                            placeholder="Days"
                            value={mediDays || ''}
                            onChange={(e) => setMediDays(e.target.value)}
                          />
                          <label>Days</label>
                        </div>
                      )}

                      {mealChoice && medicationType !== '' && (
                          <div className='form-group dose'>
                            <select
                              className='form-control form-control-lg meal_select'
                              onChange={(e) => setMediWithMeal(e.target.value)}
                              value={mediWithMeal}
                            >
                              <option value=''>No Relation to Meals</option>
                              <option value='Before Meal'>Before Meal</option>
                              <option value='After Meal'>After Meal</option>
                            </select>
                            <label>With Meal</label>
                          </div>
                      )}




                    {medicationType !== '' && (
                    <div className='form-group medicine-advice'>
                      <textarea
                        rows={4}
                        className='form-control form-control-lg'
                        placeholder="Special notes for medication (if have)"
                        value={mediAdvice || ''}
                        onChange={(e) => setMediAdvice(e.target.value)}
                      />
                      <label>Medication Notes</label>
                    </div>
                    )}

                    <div className='form-group float-right mb-0'>
                      <button
                        type='button'
                        onClick={handleMedSubmit}
                        className='btn btn-primary btn-lg btn-sub medication'
                      >
                        + Add Medication
                      </button>
                    </div>

                    {medications.length !== 0 && (
                    <div>
                      {medications.map((medication, index) => (
                        <div className='form-group' key={index}>
                          <div className='card card-custom card-stretch gutter-b medicine_bg'>
                            <div className='card-body p-6'>
                              <div className='d-flex flex-wrap align-items-center medicine'>
                                <div className='icons mr-6 tablet_img_bg'>
                                  <img
                                    src={MedLogo}
                                    height={65}
                                    alt='Medicine logo'
                                  />
                                </div>
                                <div className='d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3'>
                                  <div className='d-flex align-items-start justify-content-between medicne-line'>
                                    <div className='d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3'>
                                      <span className='text-dark-65 font-size-lg mb-1'>
                                        <span className='mr-3 text-dark-75 font-weight-bolder'>
                                          {medication.medication_name}{' '}
                                          {medication.strength},
                                        </span>{' '}
                                        {medication.genetic}
                                      </span>
                                      {(medication.medication_type === 'Tablet' || medication.medication_type === 'Syrup') && <span className='text-dark-65 font-weight-bold font-size-sm my-1'>
                                        {medication.medication_type === 'Tablet' &&
                                          `${medication.medication_schedule_monring}+${medication.medication_schedule_afternoon}+${medication.medication_schedule_evening} `}
                                        {medication.medication_with_meal}
                                      </span>}
                                      {(medication.medication_type !== 'Tablet' && medication.medication_type !== 'Tablet') && <span className='text-dark-65 font-weight-bold font-size-sm my-1'>
                                        {medication.dose_drops_time_puff}
                                      </span>}
                                        {(medication.medication_type === 'Capsule' || medication.medication_type === 'Syrup') && <span className='text-dark-65 font-weight-bold font-size-sm my-1'>
                                        {medication.medication_type === 'Capsule' &&
                                          `${medication.medication_schedule_monring}+${medication.medication_schedule_afternoon}+${medication.medication_schedule_evening} `}
                                        {medication.medication_with_meal}
                                      </span>}
                                      {medication.medication_type !== 'Nebulization' && <span className='text-dark-65 font-weight-bold font-size-sm my-1'>
                                        {medication.days} Days
                                      </span>}
                                      {medication.medication_type === 'Nebulization' && <span className='text-dark-65 font-weight-bold font-size-sm my-1'>
                                        {medication.mixture_details}
                                      </span>}
                                    </div>
                                  </div>
                                  <div className='d-flex justify-content-between align-items-center medicne-line'>
                                    <span className='text-dark-65 font-weight-bold font-size-sm my-1'>
                                      <span className='mr-1 text-dark-75 font-weight-bolder'>
                                        Notes:
                                      </span>{' '}
                                      {medication.advice}
                                    </span>
                                    {/* <div
                                      className='left_right_icons d-flex flex-column up_down'
                                      style={{ marginRight: '4.5px' }}
                                    >
                                      <i style={{color: '#54b9a8', backgroundColor: '#54b9a820'}} className='ki ki-arrow-up' />
                                      <i style={{color: '#54b9a8', backgroundColor: '#54b9a820'}} className='ki ki-arrow-down' />
                                    </div> */}
                                  </div>
                                </div>
                                <div className='d-flex flex-column remove-icon'>
                                  <span
                                    onClick={() => handleDeleteMedication(medication.medication_name)}
                                    className='pointer'
                                  >
                                  <FontAwesomeIcon
                                    icon={faTrash}
                                    className="picker-icon trash-icon"
                                  />
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}




                  <div className="form-group">
                    {/*   <input
                          ref={datePickerRef}
                          type="text"
                          name="followup_date"
                          value={formValues.followup_date}
                          placeholder="Select Date"
                          className="form-control"
                          required
                          title="Please select a valid date."
                      />
                      <label>Follow-Up Date</label>*/}


                   <input type="date" name="followup_date" value={formValues.followup_date} onChange={handleInputChange}  min={today} required />
                    <label>Follow-Up Date</label>
                  </div>
              </form>
            </div>
          )}
          {activeTab === 'advice' && (
            <div className="tab-content">
              <form>
                  <div className="form-group">
                    <AsyncCreatableSelect
                      isMulti
                      cacheOptions
                      loadOptions={fetchDataAdvice}
                      defaultOptions
                      value={formValues.advice} // Set the selected values
                      onChange={(selectedAdvice) => {
                        // Map selected advice items to their values and convert to a strin
                        setFormValues((prevValues) => ({
                          ...prevValues,
                          advice: selectedAdvice || [],
                        }));
                        console.log("Selected Advice:", selectedAdvice);
                      }}
                    />
                    <label>Advice</label>
                  </div>
                </form>
              </div>
            )}

                  <button type="button" className="prev" onClick={prevStep}>Previous</button>
                  <button type="button" onClick={SavePrescription} className="next">Submit</button>
              </div>
            )}

            {/* Step 4 - Follow Up Date */}
            {step === 4 && (
              <div className="form-step follow-up">
                <h2>Prescription preview</h2>
                <form>
                  <div className="download-prescription">
                    <div className="success-container">
                      <div className="icon-circle">
                        <FontAwesomeIcon icon={faCheckCircle} className="check-icon" /> {/* Success icon */}
                      </div>
                      <p className="success-message">Prescription has been successfully created</p>
                      {lastPrescriptionId && (
                        <>
                        <a
                          href={`/prescription-preview/${lastPrescriptionId}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="download-button"
                        >
                          Download Prescription
                        </a>
                          <span className="another-prescription" onClick={reloadPage}>+ Create Another Prescription</span>
                        </>
                      )}
                    </div>
                  </div>
                </form>
              </div>
            )}

          {/* Sticky Right-Side Popup */}
          {showStickyPopup && prescriptions.length > 0 && (
            <div className="sticky-popup" ref={popupRef}>
              <div className="popup-header" onMouseDown={handleDrag}>

                <div className="avatar-circle" style={{ backgroundColor: !prescriptions[0].patient.profile_pic ? getRandomColor() : 'transparent' }}>
                  {prescriptions[0] && prescriptions[0].patient && prescriptions[0].patient.profile_pic ? (
                    <img
                          src={`${process.env.REACT_APP_AXIOS_BASE_URL}${prescriptions[0].patient.profile_pic}`} // Concatenating the base URL and profile_pic
                          alt={prescriptions[0].patient.full_name} className="avatar-circle"
                        // Ensure the profile-pic class is styled in your CSS
                        />

                  ) : (
                    <span className="initials">{getAvatarLetter(prescriptions[0].patient.name)}</span>
                  )}
                </div>

                <h4>{patientValues.name}'s Prescriptions</h4>
                <button className="popup-close-btn" onClick={closePopup}>
                  X
                </button>
              </div>
              <div className="popup-content">
                {prescriptions.map((prescription) => (
                  <div
                    className={`pre-det ${
                      parsedUserDoctorInfo &&
                      parsedUserDoctorInfo.doctor &&
                      parsedUserDoctorInfo.doctor.id == prescription.doctor.id
                        ? "self-doctor"
                        : ""
                    }`}
                    key={prescription.id}>
                    <strong className="pre-id">#{prescription.id} </strong><br/>
                    <span><strong>Date:</strong> {moment(prescription.created_at).format("Do MMM, YYYY")}</span><br/>
                    <span><strong>Time:</strong> {moment(prescription.created_at).format("h:mm A")}</span>
                    <p>
                    <strong>Doctor:</strong>
                    <div className="avatar-circle" style={{width: "45px", height:"35px",marginRight:"0px", marginLeft: "10px", backgroundColor: !prescription.doctor.profile_pic ? getRandomColor() : 'transparent' }}>
                      {prescription.doctor.profile_pic ? (
                        <img
                              src={`${process.env.REACT_APP_AXIOS_BASE_URL}${prescription.doctor.profile_pic}`} // Concatenating the base URL and profile_pic
                              alt={prescription.doctor.full_name}  className="avatar-circle"
                            // Ensure the profile-pic class is styled in your CSS
                            />

                      ) : (
                        <span className="initials" style={{lineHeight: "21px", fontSize: "14px"}}>{getAvatarLetter(prescription.doctor.full_name)}</span>
                      )}
                    </div>
                    {" "}
                    {prescription.doctor && prescription.doctor.full_name
                      ? prescription.doctor.full_name
                      : "N/A"}
                      {parsedUserDoctorInfo &&
                        parsedUserDoctorInfo.doctor &&
                        prescription.doctor &&
                        parsedUserDoctorInfo.doctor.id === prescription.doctor.id && (
                          <span> (self)</span>
                        )}
                    </p>
                    <p><strong>History:</strong> {renderDxTags(prescription.relevant_history)}</p>
                    <div className="pre-footer">
                      <div className="diag">
                      {prescription && prescription.diagnostic?.length > 0 && (
                        <>
                          <strong>Diagnostics (Amarlab)</strong>
                          {prescription.diagnostic
                            .flatMap((order) => order.orderreport) // Combine all orderreport arrays
                            .map((report) => (
                              <div key={report.id}>
                                {report.tests} (
                                <a
                                  style={{ color: "#3c84c5", textDecoration: "none" }}
                                  href={report.report}
                                  target="_blank"
                                  rel="noreferrer noopener"
                                >
                                  {report.name}
                                </a>
                                )
                              </div>
                            ))}
                        </>
                      )}


                      {prescription && prescription.reports?.length > 0 && (
                        <>
                          <strong>Diagnostics (Sneho)</strong>
                          {prescription.reports
                            .map((report) => (
                              <div key={report.id}>

                                <a title={report.note}
                                  style={{ color: "#3c84c5", textDecoration: "none" }}
                                  href={`${process.env.REACT_APP_AXIOS_BASE_URL}/media/${report.report}`}
                                  target="_blank"
                                  rel="noreferrer noopener"
                                >
                                  {report.name}
                                </a>

                              </div>
                            ))}
                        </>
                      )}


                      </div>
                      <div><Link target="_blank" style={{color:"#3c84c5", textDecoration: 'none'}} to={`/prescription-preview/${prescription.id}`}>Preview</Link></div>
                    </div>
                  </div>
                ))}
                {/* Add any extra information or actions */}
              </div>
            </div>
          )}

          </div>
        </div>
        <div className="footer-content">
            {process.env.REACT_APP_COPYRIGHT_TEXT || "© 2025, Powered by AmarLab"}
        </div>
      </div>
    </div>
  );
}

export default CreatePrescription;
